
import React from "react";
import { DefaultButton } from "office-ui-fabric-react";
import get from 'lodash/get';

const OpenButton = ({
    acceptFileType,
    iconProps,
    onProcessOpenFile,
    styles,
    text
}) => {

    const fileUploadInput = React.useRef(null);

    const handleClick = () => {
        if (fileUploadInput.current) {
            fileUploadInput.current.click();
        }
    };

    const handleChange = (e) => {
        if (onProcessOpenFile) {
            onProcessOpenFile(e?.target?.files[0] || undefined);
            if (e && e.target) {
                e.target.value = null;
            }
        }
    };

    return (
        <div className={get(styles, 'root', null)}>
            <DefaultButton
                onClick={handleClick}
                styles={{
                    root: {
                        minWidth: '16em',
                        margin: '0em 0.2em'
                    }
                }}
                text={text}
                iconProps={iconProps}
            />
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid, jsx-a11y/anchor-has-content */}
            <input
                ref={fileUploadInput}
                style={{ display: 'none' }}
                type="file"
                accept={acceptFileType}
                onChange={handleChange}
            />
        </div>
      );
};

export default OpenButton;
